module.exports = __webpack_public_path__ + "resources/img/img_sqml_di2.324c10ccd9cb9c760257bb539145b811.png";